import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Spinner from '../../components/generics/Spinner';
import DetailHeader from '../../components/generics/DetailHeader';
import SelectableInventoryTable from '../../components/generics/SelectableInventoryTable';

import { fetchReturn, fetchReturnSuccess, fetchReturnFailure } from "../../store/shipments/actions";

import { addInventoriesFromReturn } from "../../store/shipments/api";

import Alert from '../../utils/Alert';
import { showErrors } from '../../utils/Helpers';
import { withRouter } from "utils/WithRouter";

export class ReturnAddInventoryContainer extends Component {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);

    this.state = {
      boxes : [],
      errors: [],
      errorPieces: false,
      errorWeight: false,
    };

    this.alertRef = React.createRef();
  }

  componentDidMount(){
    this.props.fetchReturn(this.props.match.params.id);
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.returnDetail.loading && !this.props.returnDetail.loading) {
      let boxes = this.props.returnDetail.returnDetail.inventory_details ? this.props.returnDetail.returnDetail.inventory_details : [];
      for(var i = 0, len = boxes.length; i < len; i++) {
        boxes[i].selected = false;
        boxes[i].old = {number_items: boxes[i].number_items, weight: boxes[i].weight};
      }
      this.setState({ boxes });
    }
  };

  updateWeight = (newVal, idx) => {
    let boxes = this.state.boxes;
    boxes[idx].weight = newVal;
    (newVal > boxes[idx].old.weight || newVal < 0) ? this.setState({errorWeight: true}) : this.setState({boxes: boxes, errorWeight: false});
  };

  updateNumberOfItems = (newVal, idx) => {
    let boxes = this.state.boxes;
    boxes[idx].number_items = newVal;
    (newVal > boxes[idx].old.number_items || newVal < 0) ? this.setState({errorPieces: true}) : this.setState({boxes: boxes, errorPieces: false});
  };

  onInventorySelect = (event) => {
    const idx = event.target.value;
    let boxes = this.state.boxes;
    const newVal = boxes[idx].selected !== undefined ? !boxes[idx].selected : true;
    if (!newVal){
      boxes[idx].weight = boxes[idx].old.weight;
      boxes[idx].number_items = boxes[idx].old.number_items;
      boxes[idx].price = boxes[idx].price;
    }
    boxes[idx].selected = newVal;
    this.setState({ boxes });
  };


  confirmNewInventory = () => {
    if (this.state.boxes.length > 0){
      this.setState({ submitting: true });
      var boxes = []
      this.state.boxes.forEach((box, idx) => {
        if (box.selected) {
          const box_data = {id: box.id !== -1 ? box.id : undefined,
                            weight: box.weight !== '' ? box.weight: undefined,
                            number_items: box.number_items !== '' ? box.number_items: undefined}
          boxes.push(box_data);
        }
      });
      var data = new FormData();
      data.append("boxes", JSON.stringify(boxes))
      addInventoriesFromReturn(this.props.match.params.id, data).then((r) => {
        this.setState({ submitting: false, boxes : [] }, () => {
          this.alertRef.current.sendAlert("Items have been added to inventory", "success");
          this.props.history.push('/return/'+this.props.match.params.id);
        });
      }).catch((err) => {
        showErrors(err, this.alertRef);
        this.setState({ submitting: false });
      });
    } else {
      this.alertRef.current.sendAlert("At least one item should be added");
    }
  };

  // ---------------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------------
  spliceError = (element) => {
    var errors = this.state.errors.slice();
    var index = errors.indexOf(element);
    if(index !== -1){
      errors.splice(index, 1)
    }
    return errors;
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){
      if (!this.props.returnDetail.returnDetail){
        return (
          <div>
            <Alert ref={this.alertRef}/>
            <Spinner />
          </div>
        );
      } else {
        return (
          <div className="animated fadeIn credit-note">
            <Alert ref={this.alertRef}/>
            {/* Header */}
            <DetailHeader title="Add returned items"
                          actionTitle="Finish"
                          actionClass="btn btn-success m-0"
                          action={this.confirmNewInventory}
                          col1Title="Return ID"
                          col1Desc={this.props.returnDetail.returnDetail.id}
                          col1Link={'/return/' + this.props.returnDetail.returnDetail.id}
                          col2Title="Return Date"
                          col2Desc={moment(this.props.returnDetail.returnDetail.created_at).format('LLL')}
                          col3Title="Customer"
                          col3Desc={this.props.returnDetail.returnDetail.shipment_data.destination.name}/>

            {/* Returned items */}

            <SelectableInventoryTable list={this.props.returnDetail.returnDetail.inventory_details}
                                      inCreditNote={this.props.returnDetail.returnDetail.in_credit_note}
                                      onSelect={this.onInventorySelect}
                                      updateWeight={this.updateWeight}
                                      updateNumberOfItems={this.updateNumberOfItems}
                                      tableTitle="Returned items"
                                      isReturn={true}
                                      smallHeaderSize={true}
                                      showCostPrice={true}
                                      errorPieces={this.state.errorPieces}
                                      errorWeight={this.state.errorWeight}/>

          </div>
        );
      }
    }
  }

const mapStateToProps = (state, ownProps) => {
  return {
    returnDetail: state.shipments.returnDetail,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchReturn: (id) => {
      dispatch(fetchReturn(id)).payload.then((response) => {
        dispatch(fetchReturnSuccess(response.data));
      }, (error) => {
        dispatch(fetchReturnFailure(error));
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReturnAddInventoryContainer));
